import { defaultCurrency } from '../utils/localization/currencies'
import { defaultDateFormat } from '../utils/localization/dateFormats'
import { defaultTimeFormat } from '../utils/localization/timeFormats'
import { defaultTimezone } from '../utils/localization/timezones'
import React from 'react'
import { ConfigProviderProps } from './types'
import { currencyToSymbol } from '../utils/localization/currencySymbols'

export const ConfigContext = React.createContext<ConfigProviderProps>({
    userRoles: [],
    currency: defaultCurrency,
    currencySymbol:currencyToSymbol(defaultCurrency),
    language: 'en-US',
    timezone: defaultTimezone,
    timeFormat: defaultTimeFormat,
    dateFormat: defaultDateFormat,
    setConfig: () => undefined,
    refetchViewer: () => Promise.resolve(),
})

const ConfigProvider: React.FC<ConfigProviderProps> = ({ children, ...props }) => {
    return <ConfigContext.Provider value={props}>{children}</ConfigContext.Provider>
}

export default ConfigProvider
